import React, { useState, useEffect } from "react"
import { FaTimes } from "react-icons/fa"
import copy from "copy-to-clipboard"

import { colorArrayToHex } from "../helpers/functions"

export default ({ visible, setVisible, color }) => {
  const [confirmation, setConfirmation] = useState(false)
  const [toastStyles, setToastStyles] = useState({ transform: "scale(0)" })
  const [colorFormat, setColorFormat] = useState("")

  const copyTextToClipboard = async (color, format) => {
    if (format === "hex") {
      copy(colorArrayToHex(color))
      // navigator.clipboard.writeText(colorArrayToHex(color)).then(() => {
      setConfirmation(true)
      setColorFormat("Hex")
      // })
    } else {
      const rgb = `rgb(${color[0]}, ${color[1]}, ${color[2]})`
      copy(rgb)
      // navigator.clipboard.writeText(rgb).then(() => {
      setConfirmation(true)
      setColorFormat("RGB")
      // })
    }
  }

  useEffect(() => {
    ;(function () {
      if (confirmation) {
        setToastStyles({
          transform: "scale(1)",
        })

        setTimeout(() => {
          setToastStyles({
            transform: "scale(0)",
          })
          setConfirmation(false)
        }, 1500)
      } else {
        setToastStyles({
          transform: "scale(0)",
        })
        setConfirmation(false)
      }
    })()
  }, [confirmation])

  return (
    <div
      className="overlay"
      style={visible ? { transform: "scale(1)" } : { transform: "scale(0)" }}
    >
      <div className="popup">
        <div className="popup__header">
          <FaTimes
            style={{ cursor: "pointer" }}
            onClick={() => {
              setVisible(false)
              setConfirmation(false)
            }}
          />
        </div>
        <div className="popup__body">
          <h1>Choose your preferred format</h1>
          <div className="popup__body--space">
            <button onClick={() => copyTextToClipboard(color, "hex")}>
              Copy Hex Code
            </button>
            <button onClick={() => copyTextToClipboard(color, "rgb")}>
              Copy RGB Code
            </button>
          </div>
        </div>
      </div>

      <div className="toast" style={toastStyles}>
        {colorFormat} copied successfully!
      </div>
    </div>
  )
}
